import React from "react";
import "./Podcasts.css";
import mirnalsharma from "../../assets/Podcast/Copy of Mrinal Sharma (1).jpg";
import Aniketdeb from "../../assets/Podcast/Copy of Aniket Deb (1).jpg";
import Rajeevraj from "../../assets/Podcast/Copy of Rajeev Raj (1).jpg";
import Simarraaj from "../../assets/Podcast/Copy of Sima Raaj (1).jpg";
import Rohankurian from "../../assets/Podcast/Copy of Rohan Kurian (1).jpg";
import Ashokkurian from "../../assets/Podcast/Copy of Ashok Kurian (1).jpg";
import Vikramkochhar from "../../assets/Podcast/Copy of Vikram Kochhar.jpg";
import Anupsoni from "../../assets/Podcast/Copy of Anup Soni.jpg";
import Sumitkaul from "../../assets/Podcast/Copy of Sumit Kaul.jpg";
import Sanghyaojha from "../../assets/Podcast/Copy of Sanghya Ojha.jpg";
import Bishwadeepchatterjee from "../../assets/Podcast/Copy of Bishwadeep Chatterjee.jpg";
import dtsamirbhargava from "../../assets/Podcast/Copy of Dr. Samir Bhargava.jpg";
import advsaveenibedi from "../../assets/Podcast/Copy of Adv. Saveeni Bedi.jpg";
import shivanitanksale from "../../assets/Podcast/Copy of Shivani Tanksale.jpg";
import Vaibhavkumarresh from "../../assets/Podcast/Copy of Vaibhav Kumaresh.jpg";
import Divyanshumalthora from "../../assets/Podcast/Copy of Divyanshu Malhotra.jpg";


const podcastGroups = [
  {
    title: "OTHERS",
    items: [
      {
        name: "MRINAL SHARMA",
        image: mirnalsharma,
      },
      {
        name: "ANIKET DEB",
        image: Aniketdeb,
      },
      {
        name: "RAJEEV RAJ",
        image: Rajeevraj,
      },
      {
        name: "SIMA RAAJ",
        image: Simarraaj,
      },
    ],
  },

  {
    title: "BALANOOR PLANTATIONS",
    items: [
      {
        name: "ROHAN KURIAN",
        image: Rohankurian,
      },
      {
        name: "ASHOK KURIAN",
        image: Ashokkurian,
      },
    ],
  },

  {
    title: "THE GOLDEN HUE PRODUCTIONS",
    items: [
      {
        name: "VIKRAM KOCHHAR",
        image: Vikramkochhar,
      },
      {
        name: "ANUP SONI",
        image: Anupsoni,
      },
      {
        name: "SUMIT KAUL",
        image: Sumitkaul,
      },
      {
        name: "SANGHYA OJHA",
        image: Sanghyaojha,
      },
      {
        name: "BISHWADEEP CHATTERJEE",
        image: Bishwadeepchatterjee,
      },
      {
        name: "DT. SAMIR BHARGAVA",
        image: dtsamirbhargava,
      },
      {
        name: "ADV. SAVEENI BEDI",
        image: advsaveenibedi,
      },
      {
        name: "SHIVANI TANKSALE",
        image: shivanitanksale,
      },
      {
        name: "VAIBHAV KUMARESH",
        image: Vaibhavkumarresh,
      },
      {
        name: "DIVYANSHU MALHOTRA",
        image: Divyanshumalthora,
      },
    ],
  },
];

const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "EVENTS",
  "PODCASTS & INTERVIEWS",
  "SOCIAL AND VERTICAL FILMS",
];

const routes = {
  COMMERCIALS: "/commercials",
  "BRAND FILMS": "/brand-films",
  "CORPORATE FILMS": "/corporate-films",
  DOCUMENTARIES: "/documentaries",
  CAMPAIGNS: "/campaigns",
};


function Podcasts() {

  const goToCategory = (category) => {
    if (category === "PODCASTS & INTERVIEWS") return;

    const route = routes[category];

    if (route) {
      window.location.href = route;
    }
  };


  return (
    <main className="podcast-page">

      <div className="podcast-container">

        {/* =================================
            HEADER
        ================================= */}

        <header className="podcast-header">

          <span className="podcast-eyebrow">
            CULTURE AT WORK
          </span>

          <h1>
            PODCASTS &amp; INTERVIEWS
          </h1>

          <p>
            Conversations that go beyond the surface.
            <br />
            Real people. Raw perspectives. Powerful ideas.
          </p>

        </header>


        {/* =================================
            PODCAST GROUPS
        ================================= */}

        <div className="podcast-content">

          {podcastGroups.map((group) => (

            <section
              className={`podcast-group ${
                group.items.length === 2
                  ? "two-items"
                  : ""
              }`}
              key={group.title}
            >

              <h2 className="podcast-group-title">
                {group.title}
              </h2>


              <div className="podcast-grid">

                {group.items.map((item, index) => (

                  <article
                    className="podcast-card"
                    key={index}
                  >

                    <img
                      src={item.image}
                      alt={item.name}
                    />

                    <div className="podcast-card-overlay"></div>

                    <div className="podcast-card-name">
                      {item.name}
                    </div>

                  </article>

                ))}

              </div>

            </section>

          ))}

        </div>


        {/* =================================
            BOTTOM NAVIGATION
        ================================= */}

        <nav className="podcast-navigation">

          <button
            className="podcast-nav-arrow"
            onClick={() =>
              goToCategory("CAMPAIGNS")
            }
          >
            ←
          </button>


          <div className="podcast-nav-list">

            {categories.map((category) => (

              <button
                key={category}
                className="podcast-nav-item"
                onClick={() =>
                  goToCategory(category)
                }
              >
                {category}
              </button>

            ))}

          </div>


          <button
            className="podcast-nav-arrow"
            onClick={() =>
              goToCategory("COMMERCIALS")
            }
          >
            →
          </button>

        </nav>

      </div>

    </main>
  );
}

export default Podcasts;